(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8538,93812],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 78677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wireframes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/herlpers.js
var DEFAULT_MOBILE_IMAGE_SIZE = 350;
var DEFAULT_IMAGE_SIZE = 500;
var IMAGE_SIZES = {
    "marketplace-for-clairvoyant-services": 541,
    fernwayer: {
        default: 478,
        secondSectionView: 650
    },
    fireaway: {
        default: 425
    },
    dindon: {
        default: 440
    },
    "seven-pm-thursday": {
        default: 478
    },
    stickerbox: {
        default: 480
    },
    fairy: {
        default: 478
    },
    "open-sense": {
        default: 440
    },
    "drive-focus": {
        default: 440
    },
    tell: {
        default: 478
    },
    "travel-trivia": {
        default: 478
    },
    "cash-chat": {
        default: 478
    },
    beautonomy: 600,
    meateater: {
        default: 470
    },
    "separate-us": {
        default: 440
    },
    "fintech-app-for-credit-score": {
        default: 480
    },
    ubichat: {
        default: 500
    },
    telemojo: {
        default: 440
    },
    famlicious: 478,
    bionorica: {
        default: 500
    },
    humankind: {
        default: 515
    },
    blackbird: {
        default: 480
    },
    "software-for-mri-interpretation": 630,
    "fusion-markets": {
        default: 440
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 480
    },
    "mobile-bank-application": {
        default: 586
    },
    "forex-trading-platform": {
        default: 560
    },
    "kitchen-equipment-customizer": {
        default: 622
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 100
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 600
    },
    "ai-software-development-services": {
        firstSectionView: 208
    },
    "ai-documentation-processing": {
        firstSectionView: 522
    }
};
var MOBILE_IMAGE_SIZES = {
    fireaway: {
        default: 250
    },
    tell: {
        default: 350
    },
    "separate-us": {
        default: 180
    },
    "drive-focus": {
        default: 220
    },
    ubichat: {
        default: 220
    },
    "marketplace-for-clairvoyant-services": {
        default: 206
    },
    "fusion-markets": {
        default: 206
    },
    telemojo: {
        default: 206
    },
    blackbird: {
        default: 350
    },
    dindon: {
        default: 181
    },
    humankind: {
        default: 181
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 240
    },
    "mobile-bank-application": {
        default: 550
    },
    "forex-trading-platform": {
        default: 228
    },
    meateater: {
        default: 211
    },
    "kitchen-equipment-customizer": {
        default: 206
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 40
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 320
    },
    "ai-software-development-services": {
        firstSectionView: 188
    },
    "ai-documentation-processing": {
        firstSectionView: 206
    }
};

;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/useWireframes.js






var useWireframes = function(param) {
    var images = param.images, type = param.type, view = param.view;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var wireframeImages = images === null || images === void 0 ? void 0 : images.map(function(image) {
        var ref, ref1;
        var imageData = (0,helper/* getImage */.gJ)(image);
        var height = isMobileResolution ? ((ref = MOBILE_IMAGE_SIZES[type]) === null || ref === void 0 ? void 0 : ref[view || "default"]) || DEFAULT_MOBILE_IMAGE_SIZE : ((ref1 = IMAGE_SIZES[type]) === null || ref1 === void 0 ? void 0 : ref1[view || "default"]) || DEFAULT_IMAGE_SIZE;
        var scale = height / imageData.height;
        var width = Math.trunc(imageData.width * scale);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            width: width,
            height: height
        });
    });
    return {
        type: type,
        images: images,
        wireframeImages: wireframeImages,
        isMobileResolution: isMobileResolution
    };
};

// EXTERNAL MODULE: ./UI/components/Wireframes/styles.module.scss
var styles_module = __webpack_require__(5665);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Wireframes/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Wireframe = function(props) {
    var ref = useWireframes(props), type = ref.type, wireframeImages = ref.wireframeImages;
    if (!wireframeImages) {
        return null;
    }
    return wireframeImages === null || wireframeImages === void 0 ? void 0 : wireframeImages.map(function(param) {
        var url = param.url, alt = param.alt, height = param.height, width = param.width;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            delay: 100
        }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default())[type], (styles_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    })
                ]
            })
        }), url);
    });
};
Wireframe.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().instanceOf(Object)).isRequired,
    type: (prop_types_default()).string.isRequired,
    view: (prop_types_default()).string
};
/* harmony default export */ var Wireframes = (Wireframe);


/***/ }),

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WireframesSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Wireframes/index.jsx + 2 modules
var Wireframes = __webpack_require__(78677);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/WireframesSection/styles.module.scss
var styles_module = __webpack_require__(67564);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/WireframesSection/utils/useWireframesSection.js




var useWireframesSection = function(param) {
    var section = param.section, data = param.data, type = param.type;
    var ref = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "subtitle",
        "description",
        "images",
        "view", 
    ], {
        isNormilized: data
    }), title = ref.title, subtitle = ref.subtitle, description = ref.description, images = ref.images, view = ref.view;
    var sectionBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "background", {})), {
        fm: "png"
    });
    var sectionProps = {
        style: sectionBackgroundImage ? {
            backgroundImage: "url(".concat(sectionBackgroundImage, ")")
        } : {},
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container)
    };
    return {
        type: type,
        view: view,
        title: title,
        images: images,
        subtitle: subtitle,
        description: description,
        sectionProps: sectionProps
    };
};

;// CONCATENATED MODULE: ./UI/sections/WireframesSection/index.jsx









var WireframesSection = function(props) {
    var ref = useWireframesSection(props), type = ref.type, view = ref.view, title = ref.title, images = ref.images, description = ref.description, subtitle = ref.subtitle, sectionProps = ref.sectionProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                titleStyle: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wireframes/* default */.Z, {
                images: images,
                type: type,
                view: view
            })
        ]
    }));
};
WireframesSection.prototype = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_WireframesSection = (WireframesSection);


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ANIMATION_CASE_STUDY_PROPS; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);

var ANIMATION_CASE_STUDY_PROPS = {
    type: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ANIMATED_TYPE.isFade */ .BK.isFade,
    duration: 1000
};


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 5665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZQHkg","animatedContainer":"styles_animatedContainer__WYfJB","image-scroll":"styles_image-scroll__pUNL8","stickerbox":"styles_stickerbox__y5DTR","image":"styles_image__bGCuA","fireaway":"styles_fireaway__l2P6I","seven-pm-thursday":"styles_seven-pm-thursday___Cl7g","open-sense":"styles_open-sense__Yklmv","drive-focus":"styles_drive-focus__12y7P","separate-us":"styles_separate-us__TLw4a","ubichat":"styles_ubichat__jbYPB","bionorica":"styles_bionorica__SM7Vw","fusion-markets":"styles_fusion-markets__H5xo9","beautonomy":"styles_beautonomy__ymseQ","meateater":"styles_meateater__qWYXE","mobile-music-app":"styles_mobile-music-app__hRFB5","blinking":"styles_blinking__7Ds4t","swing":"styles_swing__rXIHm","animateborder":"styles_animateborder__DhniH","animateborder-overlay":"styles_animateborder-overlay__8FnUW","animatecircle":"styles_animatecircle__kwr9O","animatedot":"styles_animatedot__9xDD6","animStar":"styles_animStar__EbuN6","hideText":"styles_hideText__hmhu8","spin":"styles_spin__8Cp8N","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__vtAMq","outOfTransparencyMobile":"styles_outOfTransparencyMobile__lpcr9","appearance":"styles_appearance__bMdbB","appearanceFromBelow":"styles_appearanceFromBelow__FL2aE","flicker":"styles_flicker__IS6Zf","vibrate1":"styles_vibrate1__jFR_O","rocket":"styles_rocket__zssUG","burgerItem1":"styles_burgerItem1__fTxlS","burgerItem2":"styles_burgerItem2__O_WVU","burgerItem3":"styles_burgerItem3__nrRQL","burgerItem1Reverse":"styles_burgerItem1Reverse__UKx57","burgerItem2Reverse":"styles_burgerItem2Reverse__IOcVP","burgerItem3Reverse":"styles_burgerItem3Reverse__O0X_q","arrow-down":"styles_arrow-down__7dLP_","image-scroll-reverse":"styles_image-scroll-reverse__Lo_CU","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Un_to","hide-image":"styles_hide-image__bPthP","stickerbox-pointer-second":"styles_stickerbox-pointer-second__Yn3ZV","stickerbox-pointer-third":"styles_stickerbox-pointer-third__OBnx_","cedar-bounce":"styles_cedar-bounce__so6an"};

/***/ }),

/***/ 67564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aw_1N","titleStyle":"styles_titleStyle__ePgGy","stickerbox":"styles_stickerbox__Xw87A","fairy":"styles_fairy__1QZty","fireaway":"styles_fireaway__Bk4HP","seven-pm-thursday":"styles_seven-pm-thursday__BU9eg","fernwayer":"styles_fernwayer__C1ZKC","open-sense":"styles_open-sense__asNoo","separate-us":"styles_separate-us__QNULL","famlicious":"styles_famlicious__1guC6","drive-focus":"styles_drive-focus__oEqif","travel-trivia":"styles_travel-trivia__MPcaQ","tell":"styles_tell__TOZf6","cash-chat":"styles_cash-chat__LXfad","ubichat":"styles_ubichat__0eUdZ","meateater":"styles_meateater__R_CjR","bionorica":"styles_bionorica__7_Xk3","fusion-markets":"styles_fusion-markets__Ct_XJ","beautonomy":"styles_beautonomy__KfBgs","image":"styles_image__QiXOA","telemojo":"styles_telemojo__eNYp_","blackbird":"styles_blackbird__SD8Ic","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__71Av5","dindon":"styles_dindon__Y7b3x","mobile-bank-application":"styles_mobile-bank-application__3Yv7f","humankind":"styles_humankind__CAU9R","titleStyles":"styles_titleStyles__LKr2d","forex-trading-platform":"styles_forex-trading-platform__E_nAq","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__itSCb","mobile-music-app":"styles_mobile-music-app__kWvnB","firstSectionView":"styles_firstSectionView__aFCYe","secondSectionView":"styles_secondSectionView__xMNq9","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__Mr8cV","ai-software-development-services":"styles_ai-software-development-services__gVw_v"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);